export const LabelText = {
  TITLE: 'Gift card',
  ADD_BUTTON: 'Buy gift cards',
  DOWNLOAD_BUTTON: 'Download report',
  ADD_GIFT_CARD: {
    TITLE: 'Buy gift cards',
    ADD_BUTTON: 'Place order'
  },
  UPLOAD_CSV_FAILED: {
    TITLE: 'Upload CSV',
    SUCCESS_MESSAGE_MULTIPLE:
      '%row% email addresses are ready to be uploaded. Gift cards can be sent to these recipients.',
    SUCCESS_MESSAGE_SINGLE:
      '%row% email address is ready to be uploaded. Gift card can be sent to this recipient.'
  },
  ADD_CONFIRM_MODAL: {
    TITLE: 'Confirm your order?',
    CONFIRM_BUTTON: 'Confirm order',
    CANCEL_BUTTON: 'Cancel'
  },
  DISCOUNT_FETCH_ERROR_MODAL: {
    TITLE: 'Unable to proceed',
    DESCRIPTION:
      'Something went wrong. Please check your network and try again later',
    CONFIRM_BUTTON: 'OK'
  },
  GIFT_CARD_LISTING: {
    CTA_TITLE: 'Celebrate work & life milestones with gift cards',
    CTA_SUBTITLE: 'Order your first gift card today!',
    CTA_BUTTON: 'Buy gift cards',
    SEARCH_PLACEHOLDER: 'Search for order number',
    VERIFICATION_CTA_TITLE: 'Verification in progress',
    VERIFICATION_CTA_SUBTITLE: 'Once verified, your company can send gift cards'
  },
  GIFT_CARD_SUMMARY_PAGE: {
    TITLE: 'Gift card summary',
    SEND_GIFT_CARD_TO_EMAIL_CTA: 'Send gift card details to my email',
    REORDER_CTA: 'Reorder this again',
    STATUS_COMPLETE_TITLE: 'Gift cards sent!',
    STATUS_COMPLETE_MESSAGE:
      'Each recipient received a %currency% %value% gift card',
    STATUS_PROCESSING_TITLE: 'Payment received',
    STATUS_PROCESSING_MESSAGE:
      'Your order of %quantity% x %currency% %value% gift card is on its way to the recipients!',
    STATUS_PENDING_TITLE: 'Pending payment',
    STATUS_PENDING_MESSAGE:
      'Complete payment within 30 days to avoid cancellation of your order. Gift cards will be sent after payment is received.',
    STATUS_CANCELLED_TITLE: 'Order cancelled',
    STATUS_CANCELLED_MESSAGE:
      'Payment was not received within 30 days of placing the order',
    ORDER_DETAILS_TITLE: 'Order details',
    ORDER_DETAILS_ORDER_DATE: 'Order date',
    ORDER_DETAILS_ORDER_ID: 'Order ID',
    ORDER_DETAILS_ISSUED_ON: 'Issued on',
    ORDER_DETAILS_EXPIRES_ON: 'Expires on',
    ORDER_DETAILS_EXPIRED_ON: 'Expired on',
    VALIDITY_MESSAGE: 'Valid for %duration_period%',
    STATUS_PAYMENT_PROCESSING_TITLE: 'Processing payment',
    STATUS_PAYMENT_PROCESSING_MESSAGE:
      'Your order of %quantity% x %currency% %value% gift card is processing!',
    STATUS_PAYMENT_PAYMENT_REJECTED_TITLE: 'Payment rejected',
    STATUS_PAYMENT_PAYMENT_REJECTED_MESSAGE:
      'There was a problem with the uploaded file. Please re-upload the correct file.',
    STATUS_PARTIALLY_FAILED_TITLE: '%quantity% incorrect emails found',
    STATUS_PARTIALLY_FAILED_MESSAGE:
      'We couldn’t send the gift cards to %quantity% recipients',
    STATUS_PARTIALLY_FAILED_CTA: 'Check & re-upload CSV',
    UPLOAD_SUCCESS_TITLE: '%quantity% email addresses updated',
    UPLOAD_SUCCESS_MESSAGE: 'We’ll send the gift cards soon!',
    UPLOAD_FAILED_TITLE: 'Error found again',
    UPLOAD_FAILED_MESSAGE: 'In case of error found again. Repeat the process.'
  },
  GIFT_CARD_RECIPIENTS: {
    TITLE: 'Gift card recipients',
    USER_COUNT_MULTIPLE_LABEL: 'users',
    USER_COUNT_SINGLE_LABEL: 'user',
    DOWNLOAD_CSV_CTA: 'Download CSV',
    ADMIN_EMAIL_SUFFIX: '(admin)',
    SUCCESS_MESSAGE_MULTIPLE: '%row% email addresses are ready to be uploaded',
    SUCCESS_MESSAGE_SINGLE: '%row% email address is ready to be uploaded',
    ERROR_MESSAGE:
      'Missing information in required fields. Please add the information required and upload the file again.'
  },
  ORDER_DETAILS: {
    TITLE: 'Order details',
    ORDER_DATE: 'Order date',
    ORDER_ID: 'Order ID',
    ISSUED_ON: 'Issued on',
    EXPIRES_ON: 'Expires on',
    EXPIRED_ON: 'Expired on'
  },
  GIFT_CARD_ORDER_CONFIRMATION: {
    TITLE: 'Order placed',
    PENDING_PAYMENT_TITLE: 'Pending payment',
    RECIPIENTS_TITLE: 'Gift card recipients',
    MESSAGE_TITLE: 'Check your email for a payment link',
    MESSAGE:
      'Please pay via bank transfer within 30 days. Gift cards will be sent after we have verified your payment and business information.',
    BACK_BUTTON: 'Back to gift cards'
  },
  GIFT_CARD_FTUE: {
    FIRST_STEP_CONTENT: 'First, choose a gift card',
    SECOND_STEP_CONTENT: 'Next, set a value for your gift card',
    THIRD_STEP_CONTENT:
      'The gift cards can be sent directly to recipients or emailed to you instead.',
    FOURTH_STEP_CONTENT:
      "Finally, write a thoughtful message to your recipients and you're done!"
  },
  GIFT_CARD_PAYMENT_FLOW: {
    TITLE: 'Pending payment',
    DESCRIPTION: 'Steps to make payment',
    STEP_ONE_TITLE: 'Step 1: Payment details',
    STEP_TWO_TITLE: 'Step 2: Share payment receipt',
    STEP_THREE_TITLE: 'Step 3: Wait for payment verification',
    STEP_THREE_DETAILS:
      "Your gift cards will be sent within 24 working hours, as soon as we've completed the payment validation process",
    UPLOAD_DESCRIPTION: 'Once payment is made, upload the confirmation receipt',
    UPLOAD_STATUS_SUCCESS: 'Uploaded successfully',
    UPLOAD_STATUS_LOADING: 'Uploading...',
    UPLOAD_STATUS_IDLE: 'Pending upload',
    UPLOAD_STATUS_ERROR: 'Upload failed, please try again',
    UPLOAD_STATUS_FILE_ERROR: 'Upload files smaller than 10MB',
    PAYMENT_LINK_TITLE: 'See payment details',
    DONE_BUTTON: 'Done'
  }
};

export const TestId = {
  DiscountAmount: 'discount-amount'
};
